import { useEffect } from 'react';

/** Head bootstrap owns branding before React, including scoped warm-cache icons. */
export default function TenantManifestLink() {
  useEffect(() => {
    const sync = () => window.ServiceTenantHead?.sync();
    const originals = {};
    sync();
    ['pushState', 'replaceState'].forEach(method => {
      const original = history[method];
      originals[method] = original;
      history[method] = function (...args) {
        const result = original.apply(this, args);
        sync();
        return result;
      };
    });
    window.addEventListener('popstate', sync);
    return () => {
      Object.entries(originals).forEach(([method, original]) => { history[method] = original; });
      window.removeEventListener('popstate', sync);
    };
  }, []);
  return null;
}
